import React from 'react'
import gql from 'graphql-tag'
import { graphql, withApollo } from 'react-apollo'

const CarTest = (props) => {
  if (!props.data.Inventory) return <div>Loading... </div>;
  const { id, year, make, model, trim, mileage, stockNo} = props.data.Inventory;
  return (
      <div>
        <img src={`http://www.wheelkinetics.com/ebay/${stockNo}/image1.jpg`} style={{ width: '100px', height: 'auto', float: 'left'}} />
        <div>{`${year} ${make} ${model} ${trim}`}</div>
        <div>{`${mileage} miles`}</div>
      </div>
  )
}

const query = gql`
  query {
      Inventory(id: "cj79sqddo1nd30154spil7cal"){
          id
          year
          make
          model
          stockNo
          trim
          mileage
          driveline
          transmission
      }
  }
  
`;

export default graphql(query, {options: ({ pathContext: pc }) => ({ variables: {id: pc.id}})})(CarTest);



// WEBPACK FOOTER //
// ./src/templates/car.js